import Component from "@lib/Component.js";
import { setStyle } from "@qneyraud/q-utils";
import { gebc, removeEvent, qs } from "@qneyraud/q-utils/umd/q-utils";

export default class RecruitmentList extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    this.items = gebc(this.el, "thumbnail-list-item", true);
    this.filterSelect = this.getFilterSelect();

    if (this.items.length === 0) return;

    this.filter = "all";

    this.initEvents();
  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
    this.filterSelect.off("change", this.onFilterChange);
    removeEvent(window, "resize");
  }

  bindMethods() {
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  initEvents() {
    this.filterSelect.on("change", this.onFilterChange);
  }

  getFilterSelect() {
    return this.children.find((child) => child.id === "input");
  }

  onFilterChange(newValue) {
    this.filter = newValue;

    this.items.forEach((el) => {
      const type = qs(el, ".thumbnail").dataset.category;

      if (newValue === "all" || newValue === type) {
        setStyle(el, {
          display: "block"
        });
      } else {
        setStyle(el, {
          display: "none"
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/RecruitmentList.js